<template>
    <div id="div_bio">
        <img src="../assets/portrait.jpg" style="width:90%; border-radius:10px">
        <p>
            <font size="+1">Research Scientist </br>
            <a style="text-decoration: none; color: #bb0000;" href="https://usa.visa.com/about-visa/visa-research.html">Visa Research</a>
            </font>
        </p>
        <p>
            <!-- <font size="+0.5">Contact:</font></br> -->
            <font size="-0">
            junpeng.wang.nk[at]</br>gmail.com</br>
            <!-- </br>
            junpenwa[at]</br>visa.com</br>
            (for business belated only, limited access)</br>
            </br> -->
            <!-- <strike>wang.7665@osu.edu</strike></br> -->
            900 Metro Center Blvd,</br>
            Foster City, CA, 94404</br>
            </font>
        </p>
        <p>
            <a style="text-decoration: none; color: #bb0000;" href="https://scholar.google.com/citations?user=6_6MH5wAAAAJ&hl=en">Google Scholar</a> </br>
            <a style="text-decoration: none; color: #bb0000;" href="https://www.researchgate.net/profile/Junpeng_Wang11">Research Gate</a> </br>
            <a style="text-decoration: none; color: #bb0000;" href="https://www.linkedin.com/feed/?trk=homepage-basic_signin-form_submit">LinkedIn</a> </br>
        </p>
    </div>
</template>

<script>
// Imports

export default {
    // data () {
    //     return {
    //         blog: {
    //             title: '',
    //             content: '',
    //             categories: [],
    //             author: ''
    //         },
    //         authors: ['The Net Ninja', 'The Angular Avenger', 'The Vue Vindicator'],
    //         submitted: false
    //     }
    // },
    // methods: {
    //     post: function(){
    //         this.$http.post('http://jsonplaceholder.typicode.com/posts', {
    //             title: this.blog.title,
    //             body: this.blog.content,
    //             userId: 1
    //         }).then(function(data){
    //             console.log(data);
    //             this.submitted = true;
    //         });
    //     }
    // }
}
</script>

<style scoped>
#div_bio *{
    box-sizing: border-box;
}
#div_bio{
    /* margin: 10px auto; */
    /* padding: 10px auto; */
    margin-top: 10px;
    padding-right: 5px;
    max-width: 500px;
}

</style>



// WEBPACK FOOTER //
// src/components/bio.vue